<template>
  <md-card>
    <md-card-header>
      <h5>{{ concept.name }}</h5>
      <h6>{{ concept.code }}</h6>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-20 md-small-size-40">
          <md-field>
            <label>Cantidad</label>
            <md-input v-model="concept.quantity"></md-input>
          </md-field>
        </div>
        <f-field label="Precio" :size="20" :value="concept.unitPriceMXN">
        </f-field>
        <f-field
          label="unitMeasurement"
          :size="20"
          :value="concept.unitMeasurement"
        >
        </f-field>
        <f-field label="description" :size="20" :value="concept.description">
        </f-field>
        <div class="md-layout-item md-size-20 md-small-size-40">
          <md-button class="md-sm md-primary md-round" @click="remove">
            <md-icon>close</md-icon>
          </md-button>
        </div>
      </div>
    </md-card-content>
    <md-card-actions> </md-card-actions>
  </md-card>
</template>

<script>
import FField from './FField'

export default {

  name: 'Concept',

  props: {
    concept: {
      type: Object,
      required: true
    }
  },

  components: {
    FField
  },

  data() {
    return {
      quantity: 0
    };
  },

  methods: {
    remove() {
      this.$emit('removed', this.concept)
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/RoadSinisters/File/Concept.vue